import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core";
import {AdminContextConsumer} from './Admin';
import MUIDataTable from "mui-datatables";
import firebaseApp from "../common/firebase";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Grid from "@material-ui/core/Grid/Grid";
import moment from "moment";
import {isNullOrUndefined} from "util";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import Avatar from "@material-ui/core/Avatar/Avatar";
import placeholder from "../assets/placeholder.svg";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import RefreshIcon from "@material-ui/icons/Refresh";
import IconButton from "@material-ui/core/IconButton/IconButton";


const firestore = firebaseApp.firestore();


const styles = theme => ({
    progress: {
        margin: theme.spacing.unit * 2,
    },
});

class Scorings extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            values: [],
        };
    }


    UNSAFE_componentWillMount() {
        this.reload();
    }

    reload = () => {
        this.setState({loading: true}, async () => {
            try {

                let fsValues = await firestore.collection("scoringResponses").orderBy("created", "desc").get();

                let values = [];

                for (const fsValue of fsValues.docs) {

                    const {created, ...other} = fsValue.data();
                    values.push({created: created.toDate(), ...other, ref: fsValue.ref});
                }

                this.setState({values: values, loading: false});
            } catch (error) {
                console.error(error);
                this.setState({loading: false});
            }

        })

    };


    render() {
        const {classes} = this.props;

        const columns = [
            {

                name: "Stars",
                field: "stars",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {

                name: "Who",
                field: "who",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <ListItem>
                                {value.src ? (
                                    <Avatar
                                        alt={value.alt}
                                        src={value.src}
                                    />
                                ) : (
                                    <Avatar
                                        alt={value.alt}
                                        src={placeholder}
                                    />)}
                                <ListItemText primary={value.primary} secondary={value.secondary}/>
                            </ListItem>

                        );
                    },
                }
            },
            {

                name: "Role",
                field: "role",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {

                name: "Whom",
                field: "whom",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <ListItem>
                                {value.src ? (
                                    <Avatar
                                        alt={value.alt}
                                        src={value.src}
                                    />
                                ) : (
                                    <Avatar
                                        alt={value.alt}
                                        src={placeholder}
                                    />)}
                                <ListItemText primary={value.primary} secondary={value.secondary}/>
                            </ListItem>

                        );
                    },
                }
            },
            {

                name: "Message",
                field: "message",
                options: {
                    filter: false,
                    sort: false
                }
            },
            {

                name: "Uid",
                field: "uid",
                options: {
                    filter: false,
                    sort: false,
                    display: "false",
                }
            },
            {

                name: "EventId",
                field: "eventId",
                options: {
                    filter: false,
                    sort: false,
                }
            },
            {

                name: "Booking Id",
                field: "bookingId",
                options: {
                    filter: false,
                    sort: false,
                    display: "false",
                }
            },
            {

                name: "Created",
                field: "created",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <React.Fragment>
                                {moment(value).format("YYYY-MM-DD, HH:mm:ss")}
                            </React.Fragment>

                        );
                    },
                }
            },
        ];


        const options = {
            filter: true,
            filterType: 'dropdown',
            selectableRows: 'none',
            responsive: 'scrollFullHeight',
            customToolbar: () =>
                <Tooltip title={"Reload Data"}>
                    <IconButton className={classes.iconButton}
                                onClick={this.reload}>
                        <RefreshIcon/>
                    </IconButton>
                </Tooltip>,

        };

        const data = this.state.values.map(value => {

            const line = [];

            for (const column of columns) {

                let field = value[column.field];

                const isGuest = value["log"].booking.uid === value["uid"];
                const who = isGuest ? value["log"].booking.guest : value["log"].event.host;
                const whom = !isGuest ? value["log"].booking.guest : value["log"].event.host;
                const role = isGuest ? "guest" : "host";


                if (column.field === "who") {
                    field = {src: who.image, alt: who.name, primary: `${who.firstname}`, secondary: value["log"].uid};
                }

                if (column.field === "whom") {
                    field = {
                        src: whom.image,
                        alt: whom.name,
                        primary: `${whom.firstname}`,
                        secondary: value["log"].whomUid
                    };
                }

                if (column.field === "role") {
                    field = role;
                }

                if (column.field === "eventId") {
                    field = value["log"].eventId;
                }

                if (column.field === "bookingId") {
                    field = value["log"].bookingId;
                }

                if (isNullOrUndefined(field)) {
                    field = "-";
                }

                line.push(field);
            }

            return line;
        });

        return (
            <React.Fragment>
                <AdminContextConsumer>
                    {({page}) => (
                        <React.Fragment>

                            {this.state.loading ? (
                                    <Grid
                                        container
                                        direction="row"
                                        justify="center"
                                        alignItems="center"
                                    >
                                        <CircularProgress className={classes.progress} size={50}/>
                                    </Grid>
                                ) :
                                (
                                    <MUIDataTable
                                        columns={columns}
                                        data={data}
                                        title={page.title}
                                        options={options}
                                    />
                                )}

                        </React.Fragment>
                    )}
                </AdminContextConsumer>
            </React.Fragment>
        );
    }
}

Scorings.propTypes = {
    classes: PropTypes.object.isRequired,
};


export default withStyles(styles, {withTheme: true})(Scorings)